module.exports = __webpack_public_path__ + "img/4-1_06.698dafac.jpg";